<template>
  <div class="ub-navbar-menu-container collapse navbar-collapse" id="navbarSupportedContent">
    <ul class="ub-navbar-menu navbar-nav">
      <!-- <NavbarMenuItem :page-class="pageClass" title="Insight"></NavbarMenuItem> -->

      <NavbarMenuMultiLevelItem
        :page-class="pageClass"
        title="API"
        :menu-dropdown="ApiPageMenuDropdown"
      ></NavbarMenuMultiLevelItem>

      <NavbarMenuItem :page-class="pageClass" title="Solution"></NavbarMenuItem>
      <NavbarMenuItem :page-class="pageClass" title="Pricing"></NavbarMenuItem>
      <NavbarMenuAuthItem :page-class="pageClass"></NavbarMenuAuthItem>
    </ul>
  </div>
</template>

<script>
import NavbarMenuItem from "@/components/fixed/navbar/navbar-menu-item";
import NavbarMenuAuthItem from "@/components/fixed/navbar/navbar-menu-auth-item";
import NavbarMenuMultiLevelItem from "@/components/fixed/navbar/navbar-menu-multi-level-item";

import { mapState, mapGetters } from "vuex";

export default {
  name: "NavbarMenu",

  components: {
    NavbarMenuItem,
    NavbarMenuAuthItem,
    NavbarMenuMultiLevelItem
  },

  props: {
    pageClass: {
      type: String,
      default: "black-navbar"
    }
  },

  data() {
    return {
      // insightPageMenuDropdown: [
      //   { name: "Company", to: "/insight/company" },
      //   { name: "News", to: "/insight/news" },
      //   { name: "opinion", to: "/insight/opinion" }
      // ],
      ApiPageMenuDropdown: [
        { name: "API Documentation", to: "/api/docs/V2.0/introduction" }
      ]
    };
  }
};
</script>

<style scoped>
#planBox {
  margin: 12px 16px;
  padding: 5px 12px;
  font-weight: normal;
  letter-spacing: 0.47px;
  font-size: 20px;
  border-radius: 4px;
  border: solid 0.6px;
  border-color: inherit;
}

#upgradeLink {
  color: #f5a623;
  border-bottom: solid 0.4px #ffffff;
}

.login {
  color: #16a8bd !important;
  cursor: pointer;
}

.login:hover {
  text-decoration: underline;
}

@media (min-width: 992px) {
  .ub-navbar-menu-container {
    display: flex;
    justify-content: flex-end;
    align-items: baseline;
  }

  .link {
    margin-right: 0.5rem;
  }
}

@media (min-width: 1200px) {
  .link {
    margin-right: 2rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/fixed/navbar/navbar-menu.vue